import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';

import StyledSearchTeaser from './searchTeaser.style';
import Headline from '../../atoms/headline/headline';
import Container from '../../layout/container/container';
import FilterTags from '../../atoms/filter-tags/filterTags';
import Copy from '../../atoms/copy/copy';

const SearchTeaser = ({ uri, headline, subline, introCopy, pageTags, ...props }) => (
  <StyledSearchTeaser {...props}>
    <Container>
      <Link href={uri} as={uri} className="searchTeaser__link">
        <div className="searchTeaser__content">
          <div className="searchTeaser__header">
            {pageTags && pageTags.length > 0 && (
              <FilterTags tags={pageTags} inverted className="searchTeaser__categories" />
            )}

            <Headline tag="h2" secondary className="searchTeaser__headline">
              {headline}
            </Headline>

            {subline && (
              <Headline tag="h3" subline className="searchTeaser__subline">
                {subline}
              </Headline>
            )}
          </div>

          {introCopy && (
            <div className="searchTeaser__text">
              <Copy
                className="searchTeaser__copy"
                dangerouslySetInnerHTML={{ __html: introCopy }}
              />
            </div>
          )}
        </div>
      </Link>
    </Container>
  </StyledSearchTeaser>
);

SearchTeaser.propTypes = {
  uri: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string,
  introCopy: PropTypes.string,
  pageTags: PropTypes.arrayOf(PropTypes.shape())
};

export default SearchTeaser;
